export default "__VITE_ASSET__BcBryU3w__"